<template>
    <login-page ref="loginPage" post-login-route="">
        <template #formLinks>
            <div></div>
        </template>
        <template #loginForm>
            <verify-code-component v-if="method === 'email'"></verify-code-component>
            <!-- Other method implementations -->
        </template>
    </login-page>
</template>

<script>
export default {
    props: {
        method: {
            type: String,
            default: 'email',
        },
    },
};
</script>
